import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import {
  ResponsiveContainer, LineChart, Line,
  XAxis, YAxis, Tooltip, CartesianGrid,
} from "recharts";

const TemperatureChart = ({
  tempData, loading,
  machines, selectedMachine, setSelectedMachine,
  selectedDate, setSelectedDate, onExport,
}) => {
  return (
    <Card className="h-100 mb-0">
      <CardHeader className="d-flex justify-content-between align-items-center flex-wrap gap-2 py-2">
        <h5 className="mb-0 font-size-14">Temperature vs Time</h5>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <select
            className="form-select form-select-sm"
            style={{ width: "auto", minWidth: 120 }}
            value={selectedMachine}
            onChange={(e) => setSelectedMachine(e.target.value)}
          >
            {Array.isArray(machines) && machines.map((m) => (
              <option key={m.id} value={m.name}>{m.name}</option>
            ))}
          </select>
          <input
            type="date"
            className="form-control form-control-sm"
            style={{ width: "auto" }}
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
          <button className="btn btn-outline-success btn-sm" onClick={onExport}>
            <i className="mdi mdi-microsoft-excel me-1" />Export
          </button>
        </div>
      </CardHeader>
      <CardBody style={{ height: "calc(100% - 56px)", minHeight: 180, padding: "10px" }}>
        {loading ? (
          <div className="d-flex align-items-center justify-content-center h-100">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={tempData} margin={{ top: 5, right: 10, bottom: 5, left: -10 }}>
              <CartesianGrid stroke="#e0e0e0" strokeDasharray="3 3" />
              <XAxis dataKey="time" interval={59} tickFormatter={(t) => t.slice(0, 5)}
                axisLine={{ stroke: "#aaa" }} tickLine={true} tick={{ fontSize: 11 }} />
              <YAxis axisLine={{ stroke: "#aaa" }} tickLine={true} tick={{ fontSize: 11 }} />
              <Tooltip formatter={(v) => v != null ? [`${v} °C`, "Temperature"] : ["N/A", "Temperature"]}
                labelFormatter={(l) => `Time: ${l}`} />
              <Line type="monotone" dataKey="temperature" dot={false}
                strokeWidth={2} stroke="#556ee6" connectNulls={false} />
            </LineChart>
          </ResponsiveContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default TemperatureChart;
